// src/features/analytics/components/StatTile.tsx
//
// Compact headline stat used inside the media Drawer and the retention panel
// (extracted from MediaAudienceDrawer with the metrics expansion so the two
// surfaces cannot drift). Same honest-empty contract as OverviewCards'
// StatCard: a null value renders dimmed empty copy, never a zero.

import { Paper, Skeleton, Text } from '@mantine/core';

/** Shared honest-empty copy (also the default for OverviewCards' StatCard). */
export const NO_DATA_COPY = 'No data yet';

interface StatTileProps {
  label: string;
  value: string | null;
  /** Shown instead of a value when the dataset is absent — never a zero. */
  emptyCopy?: string;
  secondary?: React.ReactNode;
  isLoading?: boolean;
}

export function StatTile({
  label,
  value,
  emptyCopy = NO_DATA_COPY,
  secondary,
  isLoading = false,
}: StatTileProps) {
  return (
    <Paper withBorder p="sm">
      <Text size="xs" c="dimmed" tt="uppercase" fw={500}>
        {label}
      </Text>
      {isLoading ? (
        <Skeleton height={24} mt={4} width="60%" />
      ) : value !== null ? (
        <>
          <Text size="lg" fw={600} mt={2}>
            {value}
          </Text>
          {secondary}
        </>
      ) : (
        <Text size="sm" c="dimmed" mt={4}>
          {emptyCopy}
        </Text>
      )}
    </Paper>
  );
}
